export const BASEURL = "https://rid1todo.herokuapp.com";
